export const DELETE_NOMINEE = 'NOMINEE/DELETE';
export const LOADING_STATUS = 'NOMINEE/LOADING_STATUS';
